import React from 'react'
import Link from 'gatsby-link'
import Obfuscate from 'react-obfuscate'
import { FaPaperPlaneO, FaWrench } from 'react-icons/lib/fa'

const ForHomePageContent = (
  <div className="c-remark-screen__message">
    <p>
      <b>I'm glad</b>
      <br /> 
      that you're interested in my stuff.
    </p>
    <p>
      Something to remember while you're here...
      <br /> 
      <br /> 
      Having returned from Spain to the UK after many years, <b>I'm looking for work</b> (London and home counties).
      <br /> 
      <br /> 
      If you think I could be a good fit, it would be nice to talk with you, reach me in the first instance via <b><Obfuscate email='jawford@mail.com' /></b>.
      <br /> 
      <br /> 
      Thank you
    </p>
  </div>
)

const ForContactPageContent = (
  <div className="c-remark-screen__message">
    <p>
      <b>Hi there</b>
      <br /> 
      Before leaving...
    </p>
    <p>
      at present <b>I'm looking for work</b>
      <br /> 
      (around and about London)
      <br /> 
      <br /> 
      If you might want me on your team, then we should talk
      <br />
      <br />
      write here <b><Obfuscate email='jawford@mail.com' /></b>
    </p>
    <p>
      Thank you 
      <br />
      <b>James</b>
    </p>
  </div>
)

export default (props) => { 
  const links = [ 
    { 
      path: 'toolbox', 
      icon: FaWrench 
    },
  ]

  return (
    <div className={`c-remark-screen ${props.isActive && 'c-remark-screen--is-active'}`}>
      {props.locationPathName === '/' ? ForHomePageContent : ForContactPageContent}
      {props.locationPathName === '/' &&
        <div className="c-remark-screen__links">
          {
            links.map((link) => (        
              <Link 
                key={link.path}
                className="c-remark-screen__link" 
                to={`/${link.path}/`}
                onClick={props.onClick}
                tabIndex={props.isActive ? '1' : '-1'}
              >
                <link.icon /> {link.path}
              </Link>)
            ) 
          }
        </div>
      }

      <div className="c-remark-screen__bg"></div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/RemarkScreen.jsx